import { render, staticRenderFns } from "./FlowLayout.vue?vue&type=template&id=3e617963&lang=pug"
var script = {}
import style0 from "./FlowLayout.vue?vue&type=style&index=0&id=3e617963&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports